var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-3",attrs:{"href":"https://docs.elinor-app.com/documentation/elinor-101","target":"_blank","icon":""}},[_c('v-icon',[_vm._v("mdi-help-circle-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }